import React from 'react';

const UmrahPackages = () => {

    return (
        <>
            <div className="space bg-clr pb-0 mb-5 mt-1">
                <div className="container">
                    <div className="row">
                        <div className="d-flex flex-wrap justify-content-between">
                            <div className="col-lg-5 col-md-5">
                                <div className="team-about">
                                    <h3>New, Exclusive Deal-SAVE BIG</h3>
                                    <p className='text-font mb-0'><b>Have You Got Your DM Book Activited Yet?</b></p>
                                    <ul>
                                        <li>
                                            Are You Struggling with the Cost and convenient of Hajj or Umrah?
                                        </li>
                                        <li>
                                            Are high costs keeping you away from visiting the holy cities of Makkah
                                            and Madinah?
                                        </li>
                                        <li>
                                            Alhamdulillah, we have a solution for you!
                                        </li>
                                        <li>
                                            Insha'Allah, you can now perform Hajj or Umrah without the stress of
                                            how to save money!
                                        </li>
                                        <li>
                                            "For the first time in Dhule, the world's top Harmain Sharifain presents the Harmain Falah Hajj Umrah  Campaign!”
                                        </li>
                                        <li>
                                            This is your chance to make your spiritual dream a reality and embark on your blessed journey with ease.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-2 res-img'>
                                <img src="/assets_web/img/homeSlider/Kaaba-Sharif01.png" alt="" />
                            </div>
                            <div className="col-lg-5 col-md-5">
                                <div className="urdu-section">
                                    <h3>
                                        نئی خصوصی پیشکش - بڑی بچت کریں!
                                    </h3>
                                    <ul className='ps-0'>
                                        <li>
                                            کیا آپ نے ابھی تک اپنا ڈی ایم بک (عمرہ ڈائری ) شروع کیا ؟
                                        </li>
                                        <li>
                                            کیا آپ حج یا عمرہ کی لاگت اور آسانی کے حوالے سے مشکل محسوس کر رہے ہیں؟
                                        </li>
                                        <li>
                                            کیا زیادہ اخراجات آپ کو مکہ اور مدینہ کے مقدس شہر جانے سے روک رہے ہیں؟
                                        </li>
                                        <li>
                                            الحمد للہ ہمارے پاس آپ کے لیے ایک حل ہے!
                                        </li>
                                        <li>
                                            انشاء اللہ اب آپ حج یا عمرہ ادا کر سکتے ہیں اس پریشانی کے بغیر کہ پیسہ کیسے بچایا جائے!
                                        </li>
                                        <li>
                                            دھولیہ میں پہلی بار دنیا کی بہترین حرمین شریفین پیش کرتا ہے 'ہرمین فلاح حج عمرہ مہم !
                                        </li>
                                        <li>
                                            یہ آپ کا موقع ہے کہ آپ اپنے روحانی خواب کو حقیقت میں بدلیں اور آسانی سے اپنے بابرکت سفر کا آغاز کریں۔
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className='text-center'>
                            <h3 className='sub-title'>The Solution is Here!</h3>
                            <h3 className='sub-title'>A very wonderful event in our life...!</h3>
                            <h3 className='clrgrn'>Basic Umrah Trip Proposal From India to Saudia</h3>
                            <p className='clrblk'>
                                Budget Package Tentative 15 Days Umrah Spiritual Journey Route for 1, 2, 3, 4, & 5 Year
                            </p>
                            <div className="w-100 d-flex justify-content-center">
                                <div className="trip-route text-center">
                                    <ul className='ps-0'>
                                        <li className='green'>
                                            1 YEAR ROUTE <br />
                                            ₹ 60,000
                                        </li>
                                        <li className='yellow'>
                                            2 YEAR ROUTE <br />
                                            ₹ 62,500
                                        </li>
                                        <li className='green'>
                                            3 YEAR ROUTE <br />
                                            ₹ 65,000
                                        </li>
                                        <li className='yellow'>
                                            4 YEAR ROUTE <br />
                                            ₹ 67,500
                                        </li>
                                        <li className='green'>
                                            5 YEAR ROUTE <br />
                                            ₹ 70,000
                                        </li>
                                        <li className='green'>
                                            12 Months <br />
                                            ₹ 5,000
                                        </li>
                                        <li className='yellow'>
                                            24 Months <br />
                                            ₹ 2,600
                                        </li>
                                        <li className='green'>
                                            36 Months <br />
                                            ₹ 1,800
                                        </li>
                                        <li className='yellow'>
                                            48 Months <br />
                                            ₹ 1,400
                                        </li>
                                        <li className='green'>
                                            60 Months <br />
                                            ₹ 1,170
                                        </li>
                                        <li className='green'>
                                            50 Weeks <br />
                                            ₹ 1,200
                                        </li>
                                        <li className='yellow'>
                                            1000 Weeks <br />
                                            ₹ 625
                                        </li>
                                        <li className='green'>
                                            150 Weeks <br />
                                            ₹ 435
                                        </li>
                                        <li className='yellow'>
                                            200 Weeks <br />
                                            ₹ 340
                                        </li>
                                        <li className='green'>
                                            250 Weeks <br />
                                            ₹ 280
                                        </li>
                                        <li className='green'>
                                            365 Days <br />
                                            ₹ 170
                                        </li>
                                        <li className='yellow'>
                                            700 Days <br />
                                            ₹ 90
                                        </li>
                                        <li className='green'>
                                            1050 Days <br />
                                            ₹ 60
                                        </li>
                                        <li className='yellow'>
                                            1400 Days <br />
                                            ₹ 50
                                        </li>
                                        <li className='green'>
                                            1750 Days <br />
                                            ₹ 40
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space">
                <div className="gallery-area shape-mockup-wrap pb-5">
                    <div className="container th-container">
                        <div className="row gy-10 gx-10 justify-content-center align-items-center">
                            <div className="col-md-6 col-lg-2">
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery02.PNG"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery02.PNG"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-2">
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery03.jpg"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery03.jpg"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery04.PNG"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery04.PNG"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-2">
                                <div className="gallery-card">
                                    <div className="box-img global-img csz">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery01.PNG"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery01.PNG"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-2">
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery05.jpg"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery05.jpg"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery07.PNG"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery07.PNG"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-2">
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <a
                                            href="/assets_web/img/homeSlider/Gallery06.jpg"
                                            className="popup-image"
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                            <img
                                                src="/assets_web/img/homeSlider/Gallery06.jpg"
                                                alt="gallery (image)"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="shape-mockup d-none d-xl-block"
                        data-top="-25%"
                        data-left="0%"
                    >
                        <img src="/assets_web/img/shape/line.png" alt="shape" />
                    </div>
                    <div
                        className="shape-mockup movingX d-none d-xl-block"
                        data-top="30%"
                        data-left="3%"
                    >
                        <img className="gmovingX" src="/assets_web/img/shape/shape_4.png" alt="shape" />
                    </div>
                </div>
            </div>

            <section id="team-sec">
                <div className="container">
                    <div className="row gy-4 gx-30">
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/rose-garden.jpg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Rose Garden
                                        </h3>
                                        <span className="team-desig">The rose gardens of Taif, Saudi Arbia, are famous for Damask roses, also known as Taif roses. Theseroses are harvested annually in spring to produce high-quality rose oil and rose water, renowned for their luxurious fragrance.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/al-ahsa-saudi.jpg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Al - Ahsa
                                        </h3>
                                        <span className="team-desig">Al-Ahsa is one of the world's largest oases, renowned for its vast palm groves, natural springs, and rich history. A UNESCO World Heritage Site, it offers visitors scenic landscapes, ancient caves, and the famous Al-Ahsa dates.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/al-ula-saudi.jpeg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Al - Ula
                                        </h3>
                                        <span className="team-desig">Al-'Ula is a historic gem known for its ancient Nabatean city, Madain Saleha, a UNESCO World Heritage Site. Visitors can explore its breathtaking rock formations, desert landscapes, and cultural festivals like Winter at Tantora.</span>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/Khaibar.jpeg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Khaibar
                                        </h3>
                                        <span className="team-desig">Khaibar is a historic oasis in Saudi Arabia, known for its ancient jewish fortresses and significant battels during early Islamic history. Today, it offers visitors a glimpse into its storied past and rich agricultural landscape.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/wadi-ad-dawasir.jpg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Wadi Al - Dawasir
                                        </h3>
                                        <span className="team-desig">Wadi Al Dawasir is a fertile region in Southern Saudi Arbia, known for its agricultural wealth and date farms. it serves as a green oasis in the desert and a key stop for travelers exploring the southern provinces.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/al-jauf.jpg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Al Jaouf
                                        </h3>
                                        <span className="team-desig">Al Jouf, in northern Saudi Arbia, is known for its rich agricultural, particularly olive farms, and ancient historical sites. Visitors can explore archaeological treasures like Rajajil standing stones and the Dumat Al-Jandal fortress, offering insights into the region,s deep-rooted history and culture.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/imam-turki-mosque.jpg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Imam Turki Mosque
                                        </h3>
                                        <span className="team-desig">Imam Turki bin Abdullah Mosque in Riyadh is a grand mosque known for its blend of modern and Islamic architecture. It servesas a major place of worship for daily, Friday, and Eid prayers in the city.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src="/assets_web/img/homeSlider/masji-al-rahma.jpg" alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            Masjid Al - Rahma
                                        </h3>
                                        <span className="team-desig">Masjid Al-Rahma, also known as the Floating Mosque, is located in Jeddah, Saudi Arabia, by the Red Sea coast. Yeh masjid 1985 mein banayi gayi thi aur iska unique design isko pani par floating effect deta hai, jo ise ek popular tourist attraction banata hai.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="space pb-0">
                <div className="row w-100">
                    <div className="col-lg-6 col-md-6">
                        <img src="/assets_web/img/homeSlider/Haji-sahab.PNG" alt="Haji Sahab" />
                    </div>
                    <div className="col-lg-6 col-md-6 res-trip-plan">
                        <div className="trip-route trip-plan text-center">
                            <div>
                                <h2 className='clrblu mb-0'>Fixed 20 Days</h2>
                                <p className='clrblu'>(Shuttle Bus Service)</p>
                            </div>
                            <ul className="d-inline-flex flex-wrap justify-content-center">
                                <li className='green font-30-pd'>
                                    ₹ 250 /-
                                </li>
                                <li className='yellow'>
                                    ₹ 300 Days <br />
                                    <small>(10 Months)</small>
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 75,000 /-
                                </li>
                                <li className='yellow font-30-pd'>
                                    ₹ 7,500 /-
                                </li>
                                <li className='green pt-3'>
                                    10 Months
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 75,000 /-
                                </li>
                                <li className='yellow font-30-pd'>
                                    ₹ 160 /-
                                </li>
                                <li className='green'>
                                    500 Days <br />
                                    <small>(1.5 Years)</small>
                                </li>
                                <li className='yellow font-30-pd'>
                                    ₹ 80,000 /-
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 5,000 /-
                                </li>
                                <li className='green'>
                                    16 Months <br />
                                    <small>(1.5 Years)</small>
                                </li>
                                <li className='yellow font-30-pd'>
                                    ₹ 80,000 /-
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 80 /-
                                </li>
                                <li className='yellow'>
                                    1000 Days <br />
                                    <small>(3 Years)</small>
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 85,000 /-
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 2,500 /-
                                </li>
                                <li className='yellow'>
                                    34 Months <br />
                                    <small>(3 Years)</small>
                                </li>
                                <li className='green font-30-pd'>
                                    ₹ 85,000 /-
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space pb-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 text-center">
                            <h4 className='clrblu'>Harry, Special Offer</h4>
                            <h4 className='clrgrn'>Hajj the Fifth pillar of <br /> Islam Planning and Preparatin</h4>
                            <p className='clrblk'>Hajj Package Tentative 35-40 Days Hajj Spiritual Journey Planner for 5 & 10 Year</p>
                        </div>
                        <div className="col-lg-6 text-center urdu-section">
                            <h4 className='clrblu'>جلدی کریں، خاص آفر </h4>
                            <h4 className='clrgrn'>حج اسلام کا پانچواں رکن: <br /> منصوبہ بندی اور تیاری</h4>
                            <p className='clrblk font-size-26'>
                                حج پیکیج : تقریباً 35-40 دنوں کا حج 5 اور 10 سال کے لیے روحانی سفر کا منصوبہ
                            </p>
                        </div>

                        {/* </div> */}

                        <div className="w-100 d-flex justify-content-center">
                            <div className="trip-route text-center">
                                <ul className='ps-0'>
                                    <li className='green'>
                                        5 YEAR PLAN <br />
                                        ₹ 5,00,000
                                    </li>
                                    <li className='green'>
                                        Monthly - 60 <br />
                                        ₹ 8,350
                                    </li>
                                    <li className='green'>
                                        Weekly - 250 <br />
                                        ₹ 2,000
                                    </li>
                                    <li className='green'>
                                        Daily - 1755 <br />
                                        ₹ 285
                                    </li>
                                    <br />
                                    <li className='yellow'>
                                        10 YEAR PLAN <br />
                                        ₹ 7,00,000
                                    </li>
                                    <li className='yellow'>
                                        Monthly - 120 <br />
                                        ₹ 5,850
                                    </li>
                                    <li className='yellow'>
                                        Weekly - 500 <br />
                                        ₹ 1,400
                                    </li>
                                    <li className='yellow'>
                                        Daily - 3500 <br />
                                        ₹ 200
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="urdu-section pb-4">
                        <h3 className='clrblu'>
                            نوٹ :
                        </h3>
                        <ul className='ps-0'>
                            <li className='font-size-26 clrblu'>
                                آپ کی تمام ادائیگیاں جو ٹرپ بک ہولڈرز کی جانب سے جمع کی جائیں گی، جیسا کہ آپ کے حج ، عمرہ، زیارت یا چھٹی کے پیکیج کے لیے طے کیا گیا ہے۔ یہ تمام رقم ہر فرد حج عمرہ کے موجودہ بینک اکاؤنٹ HFHU Vision Pvt. Ltd." میں جمع کی جائے گی۔

                            </li>
                            <li className='font-size-26 clrblu'>
                                اگر کسی ایمر جنسی کی صورت میں آپ کا جمع کیا ہوا پیسہ آپکو واپس لینا ہو تو آپ صرف ایک رقم واپسی <small>(Refund)</small> درخواست : فارم ایک مناسب وجہ کے ساتھ بھر کر جمع کروا سکتے ہیں، اور ہم بینک کے اوقات اور تعطیلات کے مطابق اپنی سہولت سے رقم واپس کر دیں گے۔
                            </li> <br />
                            <div className="dm-book-img">
                                <img src="/assets_web/img/homeSlider/Dm-Book-01.PNG" alt="DM Book" />
                            </div>
                            <div className="col-sm-9">
                                <h3 className='clrblu'>
                                    مہم ۔ اس کا طریقہ کار کیا ہے ؟
                                </h3>
                                <li className='font-size-26 clrblu'>
                                    ہم خوش ہیں کہ اس ایونٹ کو دھولیہ کے لوگوں کے ساتھ شیئر کر رہے ہیں جو ماشاء اللہ حج یا عمرہ ادا کرنے کا خواب دیکھتے ہیں!
                                </li>
                                <li className='font-size-26 clrblu'>
                                    اپنی ڈی ایم بک (عمرہ ڈائری) میں صرف 300 جمع کر کے عمرہ کی طرف اپنا سفر شروع کریں!
                                </li>
                                <li className='font-size-26 clrblu'>
                                    گفٹ عمرہ سفر پانے کا موقع، ان شاء اللہ !
                                </li>
                                <li className='font-size-26 clrblu'>
                                    اپنے روحانی سفر کا پہلا قدم اٹھائیں اور ابھی اپنی ڈی ایم بک (عمرہ ڈائری) حاصل کریں۔
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>

                <div className="green pb-0 mb-5">
                    <div className="container">
                        <div className="d-flex flex-wrap justify-content-between">
                            <div className="col-lg-5 col-md-5 pt-4">
                                <p className='clr-white font-size-18'>
                                    <b>
                                        In Quran, Hajj for those who are able is
                                        mentioned in Surah Al-Imran (3:97):
                                        "And [due] to Allah from the people is a duty to
                                        perform Hajj to the House- for whoever is able to
                                        find a way there. But whoever disbelieves [i.e.,
                                        denies Hajj] - then indeed, Allah is free from
                                        need of the worlds."
                                    </b>
                                </p>
                            </div>
                            <div className="col-lg-2 col-md-2">
                                <div className="border-wrapper">
                                    <div className="border-center" />
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-5 pt-4">
                                <div className="urdu-section">
                                    <p className='clr-white res-font'>
                                        قرآن میں ، حج کا ذکر سورہ آل عمران (3:97) میں ہے: <br />
                                        " اور لوگوں پر اللہ کا حق ہے کہ جو شخص اس کے گھر تک پہنچنے کی استطاعت رکھتا ہو ، وہ حج کرے۔ اور جو شخص کفر کرے، تو بے شک اللہ تمام جہانوں سے بے نیاز ہے۔"
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div>
                        <h6 className='clrblu mb-0'>Note:</h6>
                        <p className='text-font circle-symbol'>
                            &#9673; All your payment will be deposited on behalf of these trip book holder as decided by your Trip for Umrah / Hajj / Ziyarat / Holiday Package Etc in HarmainFalahHajjUmrah current bank account Name: <b>HFHU Vision Pvt. Ltd</b>.
                        </p>
                        <p className='text-font circle-symbol'>
                            &#9673; You can withdraw your payment if emergency needed by just filling a refund request from with a valid reason and we will arrange with our convenience as per bank timing and bank holidays.
                        </p>
                        <h6 className='clrblu mb-0'>Campaign - Here's How it Works?</h6>
                        <p className='text-font'>
                            We are excited to share this event with the people of Dhule who dream of performing Hajj or
                            Umrah, Masha'Allah!
                        </p>
                        <p className='text-font circle-symbol'>
                            &#9673; Start your journey towards Umrah with just depositing ₹300 in your DM Book!
                        </p>
                        <p className='text-font circle-symbol'>
                            &#9673; A chance to win a FREE Umrah Trip, Insha ’Allah! <br /> Take the first step toward your spiritual journey and grab your DM Book now.
                        </p>
                    </div>
                </div>

            </div>

        </>
    )
}

export default UmrahPackages
